var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.logout}},[_vm._v(" выход ")])}
var staticRenderFns = []

export { render, staticRenderFns }